// 用户相关API
import request, { serviceV1 } from '@/utils/request'

/**
 * 关于我们--设置中心
 * @returns {Promise}
 */
export function getAboutUs(data) {
    return request({
        url: '/662338375947d',
        method: 'post',
        data
    })
}
/**
 * 获取平台公告
 * @returns {Promise}
 */
export function getmessageList(data) {
    return request({
        url: '/6625d02826c40',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学员列表
 * @returns {Promise}
 */
export function getstudentlist(data) {
    return request({
        url: '/69c4ef3c40642',
        method: 'post',
        data
    })
}
/**
 * 数字-添加学员
 * @returns {Promise}
 */
export function addStudentlist(data) {
    return request({
        url: '/69c4e9a853124',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学员信息
 * @returns {Promise}
 */
export function getStudentlistInfo(data) {
    return request({
        url: '/69c4f73986141',
        method: 'post',
        data
    })
}
/**
 * 数字-编辑学员
 * @returns {Promise}
 */
export function editStudentlist(data) {
    return request({
        url: '/69c4fcd0a65fc',
        method: 'post',
        data
    })
}
/**
 * 数字-删除学员
 * @param {Object} data { aid }
 * @returns {Promise}
 */
export function delStudentlist(data) {
    return request({
        url: '/69c4f5e0b4512',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学员试卷
 * @returns {Promise}
 */
export function getSheetstudent(data) {
    return request({
        url: '/69c510a3a1840',
        method: 'post',
        data
    })
}
/**
 * 数字-提交试卷
 * @returns {Promise}
 */
export function addSheetstudentanswer(data) {
    return request({
        url: '/69c512183b9e9',
        method: 'post',
        data
    })
}
/**
 * 数字-查看答题卡
 * @returns {Promise}
 */
export function getAnswerInfo(data) {
    return request({
        url: '/69c518c413070',
        method: 'post',
        data
    })
}
/**
 * 数字-获取智能测试列表
 * @returns {Promise}
 */
export function getIntelligenttesting(data) {
    return request({
        url: '/69c5001d3194b',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学习类型
 * @returns {Promise}
 */
export function getlearningtypeList(data) {
    return request({
        url: '/69c4e8909ed7a',
        method: 'post',
        data
    })
}

/**
 * 数字-获取学校列表
 * @param {Object} data 分页与筛选，如 name、page、list_rows
 * @returns {Promise}
 */
export function getschoolList(data) {
    return request({
        url: '/69c4ea95c93d9',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学校列表-分页
 * @param {Object} data 分页与筛选，如 name、page、list_rows
 * @returns {Promise}
 */
export function getschoolListPage(data) {
    return request({
        url: '/69c9de0722a9c',
        method: 'post',
        data
    })
}
/**
 * 数字-添加学校
 * @param {Object} data { name: 学校名称 }
 * @returns {Promise}
 */
export function addSchool(data) {
    return request({
        url: '/69c4ea0e19d6f',
        method: 'post',
        data
    })
}
/**
 * 数字-获取年级列表
 * @returns {Promise}
 */
export function getgradelist(data) {
    return request({
        url: '/69c4e7022ea60',
        method: 'post',
        data
    })
}
/**
 * 数字-获取教材列表
 * @returns {Promise}
 */
export function getTextbooklist(data) {
    return request({
        url: '/69c4e74bb6eec',
        method: 'post',
        data
    })
}
/**
 * 数字-查询科目列表
 * @returns {Promise}
 */
export function getSubjectlist(data) {
    return request({
        url: '/69c4e5bd92b90',
        method: 'post',
        data
    })
}
/**
 * 数字-获取学校信息
 * @returns {Promise}
 */
export function getSchoolInfo(data) {
    return request({
        url: '/69c4f8bd23a5a',
        method: 'post',
        data
    })
}
/**
 * 数字-编辑学校
 * @param {Object} data { aid, name: 学校名称 }
 * @returns {Promise}
 */
export function editSchool(data) {
    return request({
        url: '/69c4f96280402',
        method: 'post',
        data
    })
}
/**
 * 数字-删除学校
 * @param {Object} data { aid }
 * @returns {Promise}
 */
export function delSchool(data) {
    return request({
        url: '/69c4f85dc5086',
        method: 'post',
        data
    })
}

/**
 * 省市区树（四级含街道，前端级联会截断为省/市/区）
 * https://store.saizhuge.net/api/v1/6789c02f24420
 */
export function getRegionTree(data) {
  return serviceV1({
    url: '/6789c02f24420',
    method: 'post',
    data: data || {},
    timeout: 120000
  })
}

